var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1239_11086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.32784 9.87184C7.62952 10.3266 7.53933 9.94759 7.53933 19.0123C7.53933 19.8235 8.42781 20.2878 9.05397 19.8025C11.7297 17.7011 12.2643 17.5191 12.2643 16.5362C12.2643 9.93059 12.1904 10.302 12.4758 9.87184L16.8209 3.71094H2.98279L7.32784 9.87184Z",
    fill: "#FDD116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4625 0.502343C18.3073 0.192578 18.0028 0 17.6676 0H2.13673C1.41279 0 0.986823 0.850667 1.4021 1.46875C1.40551 1.47468 1.35497 1.40262 2.1566 2.53907H17.6476C18.3308 1.57058 18.7875 1.15215 18.4625 0.502343Z",
    fill: "#FDD116"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1239_11086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileFilterIcon);
export default __webpack_public_path__ + "static/media/profile_filter_icon.cd3469b40b2432a046613258dbc29f86.svg";
export { ForwardRef as ReactComponent };